import React from "react";

const GoogleMapEmbed = ({ lat, lng }) => {
  return (
    <div style={{ position: "relative" }}>
      <iframe
        loading="lazy"
        allowFullScreen
        src={`https://www.google.com/maps?q=${lat},${lng}&hl=es&z=14&t=k&output=embed`}
      ></iframe>
    </div>
  );
};

export default GoogleMapEmbed;
